import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
// import link from '../../../../../assets/link.json'


@Component({
    selector: 'app-customer-link-generation',
    templateUrl: './customer-link-generation.component.html',
    styleUrls: ['./customer-link-generation.component.scss']
})



export class CustomerLinkGenerationComponent implements OnInit {
    msgs: { severity: string; summary: string; detail: string; }[];

    constructor(public _apiService: ApiServiceService, public _utility: AppUtility, private route: Router) { }
    customers: any;
    loading: boolean = true;
    submitButton: boolean = false;
    ngOnInit(): void {
        this.getSupplier();
    }

    breadcrumb = [
        {
            title: 'Customer Link Generation',
            subTitle: 'Dashboard'
        }
    ]
    dateFilterVal: string;
    filterval: string;


    //form group
    AddSupplierFormControl = new FormGroup({
        emailAddress: new FormControl('', [Validators.required, Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]),
        phone: new FormControl(null, [Validators.maxLength(15), Validators.minLength(10)]),
        countryCode: new FormControl('+91'),
        // createUserEmail: new FormControl('')
    })
    storageData: any;
    //submit function
    AddSupplierSubmit(addSupplier: FormGroupDirective) {
        console.log(this.AddSupplierFormControl.valid);
        this.submitButton = true;
        if (this.AddSupplierFormControl.valid) {
            console.log(this.AddSupplierFormControl.value.phone);
            this._utility.loader(true);
            this.storageData = JSON.parse(localStorage.getItem('UserObject'))
            let object = {
                // mobileNo: this.AddSupplierFormControl.value.countryCode + '-' +this.AddSupplierFormControl.value.phone,
                emailAddress: this.AddSupplierFormControl.value.emailAddress,
                csTeam: this.storageData?.loginName
                // createUserEmail: this.storageData?.loginName
            }
            if (this.AddSupplierFormControl.value.phone) {
                object['mobileNo'] = this.AddSupplierFormControl.value.countryCode + '-' + this.AddSupplierFormControl.value.phone;
            }

            this._apiService.generateLinkForCustomer(object)
                .then((res: any) => {
                    this._utility.loader(false);
                    console.log(res);
                    if (res.success == false) {
                        this.submitButton = false;
                        this._apiService.showMessage(res.message, 'error')
                    }
                    else {
                        this.submitButton = false;
                        this._apiService.showMessage(res.message, 'success')
                        this.AddSupplierFormControl.reset();
                        Object.keys(this.AddSupplierFormControl.controls).forEach(key => {
                            this.AddSupplierFormControl.controls[key].setErrors(null)
                        });
                        addSupplier.resetForm();
                        this.AddSupplierFormControl.controls['countryCode'].setValue('+91')
                        setTimeout(() => {
                            // Redirect to a new page in a new tab or window
                            // window.open('http://localhost:62177/verification/Customer', '_blank');
                            window.open('https://idexportal.in/verification/Customer', '_blank');
                        }, 1500);
                    }
                    this.getSupplier();
                })
        }

    }

    totalRecords: any;
    getSupplier() {
        this._utility.loader(true);
        this._apiService.getAllLinkedCustomer().then((res: any) => {
            this._utility.loader(false);
            console.log(res);
            this.loading = false;
            if (res.success == true) {
                this.customers = res.returnValue;
                this.totalRecords = this.customers[0].totalRecords
            }

            else {
                this.customers = [];
            }
        })
            .catch((error: any) => {
                this._utility.loader(false);
                this.customers = [];
            })
    }

    clear(table: any) {
        table.clear();
    }

    reset(dt2) {
        dt2.reset();
        this.filterval = '';
        this.dateFilterVal = ''
    }

    // bulkUpload() {
    //     this._utility.loader(true);
    //     link.forEach((res: any , index:any) => {
    //         console.log(res['Email Address']);
    //             let object = {
    //                 emailAddress: res['Email Address']
    //             }
    //             this._apiService.generateLinkForSupplier(object)
    //             .then((res: any) => {
    //                 this._utility.loader(false);
    //                 console.log(res);
    //                 if (res.success == false) {
    //                     this.submitButton = false;
    //                     this._apiService.showMessage(res.message, 'error')
    //                 }
    //                 else {
    //                     this.submitButton = false;
    //                     this._apiService.showMessage(res.message, 'success')
    //                     this.AddSupplierFormControl.reset();
    //                     Object.keys(this.AddSupplierFormControl.controls).forEach(key => {
    //                         this.AddSupplierFormControl.controls[key].setErrors(null)
    //                     });
    //                     this.AddSupplierFormControl.controls['countryCode'].setValue('+91')
    //                 }
    //                 this.getSupplier();
    //             })
    //     })
    // }
}